/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import { GRAY_DARK } from '../../../theme/colors'

export const Container = styled.div``

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 12px;
  padding: 0 10px;
`

export const ColorsIcon = styled.img`
  width: 16px;
  margin-right: 10px;
`

export const ActiveColorsLabel = styled.div`
  color: ${GRAY_DARK};
  font-size: 22px;
  font-weight: 500;
  line-height: 100%;
  padding-top: 26px;
  margin-left: 30px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/BaseColors/styledComponents.tsx